import { Footer } from '@numa-group/ui.footer';
import { WhiteLabelFooter } from '@numa-group/ui.white-label-footer';

import { useBrand } from '@src/contexts/brand-context';
import { useCmsContent } from '@src/contexts/cms-content-context';
import { useAnalytics } from '@src/features/analytics/hooks';
import { AnalyticsEvent } from '@src/features/analytics/types';
import { useUserConsent } from '@src/features/user-consent/hooks';
import { useLocale } from '@src/hooks/use-locale';
import { i18nConfig } from '@src/i18n/locales';

export const FooterV2 = () => {
  const locale = useLocale();
  const { siteLink, homePage, misc } = useCmsContent();
  const { showConsentModal } = useUserConsent();
  const { brand, isNativeBrand } = useBrand();
  const { trackEvent } = useAnalytics();

  if (isNativeBrand) {
    // We remove the default locale prefix since the website omits it
    const localePrefix = locale === i18nConfig.defaultLocale ? '' : `/${locale}`;

    const urls = siteLink.copyright.map((link) => ({
      label: link.label,
      href: new URL(`${localePrefix}/${link.route.path}`, brand.websiteUrl),
    }));

    return (
      <WhiteLabelFooter
        style={{
          '--white-label-footer-background-color': brand.primaryColor?.hex,
          '--white-label-footer-color': brand.textColor?.hex,
        }}
        logo={{
          ...brand.logo,
          href: brand.websiteUrl,
        }}
        urls={urls}
        content={{
          privacySettings: siteLink.dataPreference,
        }}
        onShowConsentModal={showConsentModal}
      />
    );
  }

  const onFAQClick = () => {
    trackEvent({
      event: AnalyticsEvent.FAQFooterClicked,
      properties: {},
    });
  };

  return (
    <Footer
      variant="large"
      websiteUrl="https://numastays.com"
      onShowConsentModal={showConsentModal}
      onFAQClick={onFAQClick}
      content={{
        siteLink,
        homePage,
        i18n: {
          copyrightText: misc.copyrightText,
        },
      }}
      locale={locale}
    />
  );
};
